import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "audience-management-header-table" };
const _hoisted_2 = {
    key: 0,
    class: "audience-management-header-table__options-header"
};
const _hoisted_3 = { class: "audience-management-header-table__wrapper" };
const _hoisted_4 = { class: "audience-management-header-table__search" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-search" }, null, -1);
const _hoisted_6 = ["placeholder", "onKeypress"];
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("i", { class: "icon ml--4 icon-upload-14px" }, null, -1);
import { reactive, watch } from 'vue';
import { debounce } from 'lodash';
import vSelect from 'vue-select';
import router from '@/router';
import bus from '@/helpers/events/bus';
import { fetchTablePresets } from '../data/';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AudienceManagementHeaderTable',
    props: {
        isEmptyTable: { type: Boolean }
    },
    emits: ['selectedPreset', 'searchAudience'],
    setup(__props, { emit }) {
        const props = __props;
        const state = reactive({
            tablePresets: {
                all: '',
                integration: '',
            },
            selectedOption: { id: 'all', name: 'Todas as Audiências' },
            search: '',
            isTyping: false,
        });
        const formatPresets = (presets) => {
            if (!presets)
                return;
            return Object.entries(presets).map(preset => ({ id: preset[0], name: preset[1] }));
        };
        const fetchDataTablePresets = () => {
            fetchTablePresets().then((presets) => {
                const selectedPreset = state.selectedOption.id;
                state.selectedOption = { id: selectedPreset, name: presets[selectedPreset] };
                state.tablePresets = presets;
            });
        };
        const searchAudience = () => {
            emit('searchAudience', state.search);
        };
        const resetFilter = () => {
            state.search = '';
            emit('searchAudience', '');
        };
        watch(() => state.search, debounce(function () {
            state.isTyping = false;
        }, 1000));
        watch(() => state.isTyping, value => {
            if (!value) {
                emit('searchAudience', state.search);
            }
        });
        const selectedPreset = () => {
            emit('selectedPreset', state.selectedOption);
        };
        const createAudience = () => {
            const routeName = String(router.currentRoute.value.path);
            router.push(`${routeName}/create/`);
        };
        const importAudience = () => {
            bus.$emit('open-importation');
        };
        fetchDataTablePresets();
        return (_ctx, _cache) => {
            const _component_base_card_header = _resolveComponent("base-card-header");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_base_card_header, {
                    title: _ctx.$t('audiences-title'),
                    icon: "icon-table-30px"
                }, null, 8, ["title"]),
                (!props.isEmptyTable)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(_unref(vSelect), {
                            id: "dash-metrics-select",
                            modelValue: state.selectedOption,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((state.selectedOption) = $event)),
                            label: "name",
                            class: "audience-management-header-table__select",
                            clearable: false,
                            options: formatPresets(state.tablePresets),
                            placeholder: _ctx.$t('select'),
                            "onOption:selected": selectedPreset
                        }, {
                            option: _withCtx(({ name }) => [
                                _createTextVNode(_toDisplayString(_ctx.$t(`${name}`)), 1)
                            ]),
                            "selected-option": _withCtx(({ name }) => [
                                _createTextVNode(_toDisplayString(_ctx.$t(`${name}`)), 1)
                            ]),
                            "open-indicator": _withCtx(({ attributes }) => [
                                _createElementVNode("span", _mergeProps(attributes, { class: "arrow-down" }), null, 16)
                            ]),
                            "no-options": _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('no-results')), 1)
                            ]),
                            _: 1
                        }, 8, ["modelValue", "options", "placeholder"]),
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _hoisted_5,
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((state.search) = $event)),
                                    type: "text",
                                    class: "input-search",
                                    placeholder: _ctx.$t('audiences.placeholder-search'),
                                    onInput: _cache[2] || (_cache[2] = ($event) => (state.isTyping = true)),
                                    onKeypress: _withKeys(searchAudience, ["enter"])
                                }, null, 40, _hoisted_6), [
                                    [_vModelText, state.search]
                                ]),
                                (state.search)
                                    ? (_openBlock(), _createElementBlock("i", {
                                        key: 0,
                                        class: "icon icon-close",
                                        onClick: resetFilter
                                    }))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("button", {
                                ref: "button",
                                class: "audience-management-header-table__btn-import btn btn-outline-ctx-primary",
                                onClick: importAudience
                            }, [
                                _hoisted_7,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('audiences.import-audience')), 1)
                            ], 512),
                            _createElementVNode("button", {
                                ref: "button",
                                class: "btn audience-management-header-table__btn-create",
                                onClick: createAudience
                            }, _toDisplayString(_ctx.$t('audiences.create-new-audience')), 513)
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
